import { render, staticRenderFns } from "./formBox.vue?vue&type=template&id=64fa9277&scoped=true"
import script from "./formBox.vue?vue&type=script&lang=js"
export * from "./formBox.vue?vue&type=script&lang=js"
import style0 from "./formBox.vue?vue&type=style&index=0&id=64fa9277&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fa9277",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64fa9277')) {
      api.createRecord('64fa9277', component.options)
    } else {
      api.reload('64fa9277', component.options)
    }
    module.hot.accept("./formBox.vue?vue&type=template&id=64fa9277&scoped=true", function () {
      api.rerender('64fa9277', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/record/components/formBox.vue"
export default component.exports